import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { useEffect } from 'react';
export function ErrorPage(_a) {
    var defaultErrorMessage = _a.defaultErrorMessage, fallbackPath = _a.fallbackPath;
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var navigate = useNavigate();
    var error = useRouteError();
    useEffect(function () {
        var message = defaultErrorMessage;
        if (isRouteErrorResponse(error)) {
            message = error.data;
        }
        setSnackbarAlert({ message: message, type: 'error' });
        navigate(fallbackPath);
    });
    return _jsx(_Fragment, { children: " " });
}
